module.exports = __webpack_public_path__ + "assets/img/new-game.e315479d.svg";